import type { ColDef, ValueFormatterParams } from 'ag-grid-community';
import dateFormatter from '../../components/valueFormatter/dateFormatter';

const colDef: ColDef[] = [
  {
    headerName: '',
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: true,
    resizable: false,
    suppressMenu: true,
    suppressSizeToFit: true,
    width: 45,
  },
  {
    headerName: 'Steel Maker',
    headerTooltip: 'Steel Maker',
    field: 'メーカー名_EN',
    tooltipField: 'メーカー名_EN',
    width: 70,
  },
  {
    headerName: 'Plant',
    headerTooltip: 'Plant',
    field: 'ミル情報_EN',
    tooltipField: 'ミル情報_EN',
    width: 70,
  },
  {
    headerName: 'Products',
    headerTooltip: 'Products',
    field: '品種_EN',
    tooltipField: '品種_EN',
    width: 60,
  },
  {
    headerName: 'Section Code',
    headerTooltip: 'Section Code',
    field: '商社店部課名',
    tooltipField: '商社店部課名',
    width: 70,
  },
  {
    headerName: 'SC No.',
    headerTooltip: 'SC No.',
    field: '契約番号_商社',
    tooltipField: '契約番号_商社',
    width: 125,
  },
  {
    headerName: 'Contract No.',
    headerTooltip: 'Contract No.',
    field: '契約番号_表示',
    tooltipField: '契約番号_表示',
    width: 125,
  },
  {
    headerName: 'Grade',
    headerTooltip: 'Grade',
    field: '規格',
    tooltipField: '規格',
    width: 125,
  },
  {
    headerName: 'Size',
    headerTooltip: 'Size',
    field: '寸法_表示',
    tooltipField: '寸法_表示',
    width: 70,
    cellClass: 'cell',
  },
  {
    headerName: 'Heat No.',
    headerTooltip: 'Heat No.',
    field: '溶解番号_表示',
    tooltipField: '溶解番号_表示',
    width: 100,
  },
  {
    headerName: 'Inspection No.',
    headerTooltip: 'Inspection No.',
    field: '検査番号',
    tooltipField: '検査番号',
    width: 100,
  },
  {
    headerName: 'Condition',
    headerTooltip: 'Condition',
    field: '納入状態',
    tooltipField: '納入状態',
    width: 70,
  },
  {
    headerName: 'Customer1',
    headerTooltip: 'Customer1',
    field: '需要家1',
    tooltipField: '需要家1',
  },
  {
    headerName: 'Customer2',
    headerTooltip: 'Customer2',
    field: '需要家2',
    tooltipField: '需要家2',
  },
  {
    headerName: 'Destination',
    headerTooltip: 'Destination',
    field: '日本製鉄_輸出.仕向国',
    tooltipField: '日本製鉄_輸出.仕向国',
    width: 100,
  },
  {
    headerName: 'Port of delivery',
    headerTooltip: 'Port of delivery',
    field: '愛知製鋼_輸出.揚げ港',
    tooltipField: '愛知製鋼_輸出.揚げ港',
    width: 125,
  },
  {
    headerName: 'Bundle No.',
    headerTooltip: 'Bundle No.',
    field: '愛知製鋼_輸出.束No',
    tooltipField: '愛知製鋼_輸出.束No',
    width: 125,
  },
  {
    headerName: 'Pieces',
    headerTooltip: 'Pieces',
    field: '愛知製鋼_輸出.本数',
    tooltipField: '愛知製鋼_輸出.本数',
    // type: 'numericColumn',
    filter: 'agNumberColumnFilter',
    valueFormatter: (params: ValueFormatterParams) => {
      return params.value ? params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
    },
    cellStyle: { textAlign: 'right' },
    cellClass: 'cell',
    width: 75,
  },
  {
    headerName: 'NetWeight',
    headerTooltip: 'NetWeight',
    field: '愛知製鋼_輸出.重量',
    tooltipField: '愛知製鋼_輸出.重量',
    // type: 'numericColumn',
    filter: 'agNumberColumnFilter',
    valueFormatter: (params: ValueFormatterParams) => {
      return params.value ? params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
    },
    cellStyle: { textAlign: 'right' },
    cellClass: 'cell',
    width: 100,
  },
  {
    headerName: 'Unit',
    headerTooltip: 'Unit',
    field: '愛知製鋼_輸出.重量単位',
    tooltipField: '愛知製鋼_輸出.重量単位',
    width: 75,
  },
  {
    headerName: 'Date',
    headerTooltip: 'Date',
    field: '証明書発行年月日',
    tooltipField: '証明書発行年月日',
    valueFormatter: dateFormatter,
    width: 125,
  },
  {
    headerName: 'Certificate No.',
    headerTooltip: 'Certificate No.',
    field: '証明書番号',
    tooltipField: '証明書番号',
    width: 125,
  },
  {
    headerName: 'Customer1 Code',
    headerTooltip: 'Customer1 Code',
    field: '需要家コード1',
    tooltipField: '需要家コード1',
    width: 75,
  },
  {
    headerName: 'Customer2 Code',
    headerTooltip: 'Customer2 Code',
    field: '需要家コード2',
    tooltipField: '需要家コード2',
    width: 75,
  },
  {
    headerName: 'Delivery Site',
    headerTooltip: 'Delivery Site',
    field: '受渡場所コード',
    tooltipField: '受渡場所コード',
    width: 75,
  },
  {
    headerName: 'Delivery Site',
    headerTooltip: 'Delivery Site',
    field: '受渡場所名',
    tooltipField: '受渡場所名',
    cellRenderer: 'deliveryLocationCellRenderer',
    width: 75,
  },
  {
    headerName: 'Shipper',
    headerTooltip: 'Shipper',
    field: '商社名',
    tooltipField: '商社名',
    cellRenderer: 'tradingCompanyCellRenderer',
    width: 70,
  },
];

export default colDef;
